<template lang="html">

  <section class="a-propos">
    <div id="content">

        <div class="section" id="HomeImg">
            <div class="headtitle">
                <div class="text-center">
                    <h1>SkanTicket</h1>
                    <h2>La solution qui vous permet de vendre plus.</h2>
                </div>
            </div>
        </div>

        <!-- presentation de Skanticket -->

        <div class="section text-center" id="presentation">

            <div class="container">
                <h2>Presentation</h2>
                <p>
                    SkanTicket est un produit de Skan Technologies.
                    C'est une solution ivoirienne de billet­terie en self-service sous forme de logiciel en ligne (Software As A Service) à desti­nation des organi­sa­teurs d’événements. Simple, rapide et profes­sion­nelle, la solution est acces­sible gratui­tement et permet de créer son événement sur mesure, de proposer des billets ou invita­tions en ligne, de promouvoir son événement et de gérer le contrôle d’accès le jour J. SkanTicket compte déjà quelques organisateurs d’événements de toutes tailles qui opèrent dans tous les secteurs de l’événementiel, essen­tiel­lement en Afrique.
                </p>

            </div>
        </div>

        
            <!-- les differents contacts de skanticket -->
        <div class="section text-center" id="nousContacter">

            <div class="container">
                <h2>Nous contacter</h2>

                <small> <i class="fa fa-envelope-o" aria-hidden="true"></i> email</small>
                <p>support@skanticket.com</p>

                <small> <i class="fa fa-phone" aria-hidden="true"></i> telephone</small>
                <p>+225 0708177769</p>

                <small><i class="fa fa-map-marker" aria-hidden="true"></i> localisation</small>
                <p>Abidjan - Côte d'Ivoire</p>

            </div>
        </div>


    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'a-propos',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style>
  .section#HomeImg
  {
      background-image: url(../assets/img/apropros.jpg);
      /* height: 39em; */
      position: relative;
      overflow-y: hidden;
      padding-top: 0;
      padding-bottom: 0;
      background-blend-mode: color-burn;
      background-color: rgba(13, 64, 132, 0.7);
      background-size: cover;
      background-position: center center;
      padding: 15em 0;
  }
  .headtitle {
      color: #FFF;
  }

  .headtitle h1{
      font-size: 4em;
  }
  #presentation, #nousContacter{
      padding: 5em 0;
  }
  #presentation p {
      text-align: justify;
  }

  #nousContacter{
      background: #e6e6e6;
  }

  #nousContacter p{
      font-size: 1.5rem;
  }
  #nousContacter small{
      font-size: 1rem;
      color: #616161;
  }

  #presentation h2, #nousContacter h2{
      /* font-size: 2rem; */
      margin-bottom: 1em;
      color: var(--sk-darkblue);
  }
</style>
